export enum StatusEnum {
  LOGIN = 'login',
  NO_IMG = 'noimg',
  NOT_ACTIVATED = 'not_activate',
  LOGGED_OUT = ''
}
